import { defaultMessageDto, MessageDto } from "src/dtos/message/messageDto";

export interface SYS1020_R01Dto extends MessageDto {
    listLength?: number;
    refetchListLength?: number;
}

export const defaultSYS1020_R01Dto: SYS1020_R01Dto = {
    ...defaultMessageDto,
};
